var View = require('views/base/view');
var TimeoutService = require('services/timeout-service');


var TapSelectionQuestionView = View.extend({
  autoRender: true,
  template: require('./templates/tap-selection-question'),

  activitySettings: undefined,

  questionDelayTimeout: null,
  questionSelectionTimeout: null,
  questionAnswered: false,
  questionElements:undefined,

  regions: {},

  load: function() {
    this.activitySettings = this.model.get('activitySettings');
    this.regions = this.model.get('regions');
    this.initializeQuestion();
  },

  dispose: function() {
    this.clearQuestionTimers();
    View.prototype.dispose.apply(this, arguments);
  },

  // sets/renders a question based on the current position of the question iterator
  initializeQuestion: function() {
    let answers = this.model.get('answers');
    this.model.set('answers', answers);
    this.questionElements = $(this.regions.question+' .question-answer');
    for(var i = 0; i < this.questionElements.length; i++) {
      $(this.questionElements[i]).attr('answerid', answers[i].id).addClass('answer-'+i);
    }
    this.startQuestionTimers();
    this.delegate('click', '.question-answer', (e)=>{this.answerQuestion(e);});
    this.questionAnswered = false;
  },

  // clear timeouts and intervals if they exist
  clearQuestionTimers: function() {
    if(this.questionDelayTimeout !== null) {
      this.questionDelayTimeout.clear();
    }
    if(this.questionSelectionTimeout !== null) {
      this.questionSelectionTimeout.clear();
    }
  },


  // kick off timers with the start of a new question
  startQuestionTimers: function() {
    if(this.activitySettings.question_timeout !== -1) {
      this.questionSelectionTimeout = new TimeoutService(this.activitySettings.question_timeout,
        ()=>{
          this.questionTimeout();
        });
      if(this.questionSelectionTimeout !== null) {
        this.questionSelectionTimeout.clear();
      }
    }
  },

  // timeout that registers if the user takes too long to answer
  questionTimeout: function() {
    this.clearQuestionTimers();

    $(this.regions.question).addClass('unanswered incorrect');
    this.questionElements.removeClass('selected');
    this.applyAnswerClasses();

    this.trigger('question:timeout', {
      feedback: this.model.get('feedback'),
      answerElement: $('.game-container')
    });
  },

  // fired when the submit button is clicked, checks the answer selected
  answerQuestion: function(e) {
    this.$el.off('click', '.question-answer');

    let selected = $(e.currentTarget);
    let answer = parseInt(selected.attr('answerid'),10);
    selected.addClass('selected');

    this.clearQuestionTimers();
    let correct = this.checkQuestionCorrect(answer);

    $(this.regions.question).addClass(`answered ${correct === true?'correct':'incorrect'}`);

    this.applyAnswerClasses();

    this.question_timeout = new TimeoutService(this.activitySettings.question_delay,
      ()=>{
        this.trigger('question:feedback', {
          correct: correct,
          feedback: this.model.get('feedback'),
          answerElement: $('.game-container')
        });
      });

    this.question_timeout.play();

    this.trigger('question:answered', {
      correct: correct
    });
  },

  // apply classes to the answer elements based on whether they are inherently correct
  applyAnswerClasses: function() {
    let correctArray = this.model.get('correct');
    this.model.get('answers').forEach((e, i)=>{
      if(_.indexOf(correctArray, e.id) !== -1) {
        $(this.questionElements[i]).addClass('correct');
      } else {
        $(this.questionElements[i]).addClass('incorrect');
      }
    });
  },

  // is the selected answer correct?
  checkQuestionCorrect: function(selectedAnswer) {
    let isCorrect = false;
    let correctArray = this.model.get('correct');
    for(var i = 0; i < correctArray.length; i++) {
      if(selectedAnswer === correctArray[i]) {
        isCorrect = true;
      }
    }
    return isCorrect;
  }
});

module.exports = TapSelectionQuestionView;


